import React, { useRef } from "react";
import {
  Container,
  Box,
  Text,
  VStack,
  Link,
  Icon,
  Center,
} from "@chakra-ui/react";
import { RiWhatsappFill, RiPhoneFill } from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import { FiCheckCircle } from "react-icons/fi";

function Successful() {
  const windowSize = useRef([window.innerWidth, window.innerHeight]);
  return (
    <>
      <Container my="20">
        <Box
          p="40px 30px 20px 30px"
          style={{ boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.2)" }}
        >
          <VStack textAlign="center">
            <FiCheckCircle color="#468c32" fontSize="80px" py="20px" />
            <Text fontSize="30px">Congratulations</Text>
            <Text fontSize="20px" color="gray" pb="10px">
              You have successfully registered! Kindly check your email for
              confirmation. Please contact
              <span>
                <b> HOLISTICS LAB SDN BHD </b>
              </span>
              for any inqueries.
            </Text>
            <Text fontSize="20px" pb="20px">
              Thankyou for your participation.
            </Text>
            <Box
              w="150px"
              p="5px"
              color="white"
              bgColor="#468c32"
              borderRadius="10px"
            >
              <Link href="/">Go to Home</Link>
            </Box>
          </VStack>
        </Box>
        {windowSize.current[0] < 500 && (
          <Box my="30px">
            <VStack>
              <Text fontStyle="italic" fontSize="15px" textAlign="left">
                <Icon as={MdEmail} /> Email: admin@holisticslab.my
                <br />
                <Icon as={RiPhoneFill} /> 07-5950920 (Office)
                <br />
                <Icon as={RiWhatsappFill} /> 019-7765075 (WhatsApp)
              </Text>
            </VStack>
          </Box>
        )}
      </Container>
      {windowSize.current[0] > 500 && (
        <Box my="30px">
          <Center>
            <Text fontStyle="italic" fontSize="15px" textAlign="left">
              <Icon as={MdEmail} /> Email:
              admin@holisticslab.my&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Icon as={RiPhoneFill} /> 07-5950920
              (Office)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Icon as={RiWhatsappFill} /> 019-7765075 (WhatsApp)
            </Text>
          </Center>
        </Box>
      )}
    </>
  );
}

export { Successful };
